<div class="export-row export-row-padded-top export-production-imaging-options"
    [ngClass]="{'export-options-disabled': optionsDisabled}">
    <div class="export-row-column-auto">
        <div class="export-row">
            <div class="export-row-column-auto export-header" [ngClass]="{'hide-header-class': isReefReviewProject}">
                Output</div>
            <div class="export-row-column-auto export-header" *ngIf="!isReefReviewProject">Output Folder (optional)</div>
            <div class="export-row-column-auto export-header options-header"
                [ngClass]="{'hide-header-class': isReefReviewProject}">Options</div>
        </div>
        <div class="export-row" *ngIf="!hideOptions"
            [ngClass]="{'export-item-selected': exportOptions.includeNativeFiles, 'export-item-disabled': optionsDisabled || disabled.includeNativeFiles}">
            <div class="export-row-column-auto" [ngClass]="{'hide-header-class': isReefReviewProject}">
                <res-custom-checkbox [automationId]="automationId + '-production-native'" content="Native"
                    [ngModel]="exportOptions.includeNativeFiles"
                    [isDisabled]="optionsDisabled|| disabled.includeNativeFiles"
                    (ngModelChange)="onChange.productionSettingType('Native')">
                </res-custom-checkbox>
            </div>
            <div class="export-row-column-auto" *ngIf="!isReefReviewProject">
                <input type="text"
                    [disabled]="optionsDisabled || !exportOptions.includeNativeFiles || disabled.includeNativeFiles"
                    (click)="exportOptions.includeNativeFiles ? $event.stopPropagation() : null"
                    [(ngModel)]="validation.directory.nativeSubdirectoryInput.name"
                    [attr.data-automation-id]="automationId + '-production-native-output-directory-input'"
                    (focusin)="validation.directory.nativeSubdirectoryInput.check()"
                    (focusout)="validation.directory.nativeSubdirectoryInput.trimLeadingSpaces()"
                    (input)="validation.directory.nativeSubdirectoryInput.lengthValidation()"
                    (ngModelChange)="validation.directory.nativeSubdirectoryInput.check()"
                    [(resScrollablePopover)]="validation.directory.nativeSubdirectoryInput.invalid"
                    [isSingleLine]="true"
                    [popoverErrorMessage]="validation.directory.nativeSubdirectoryInput.errorMessage"
                    [popoverType]="validation.directory.nativeSubdirectoryInput.errorType" popoverPlacement="bottom"
                    title="50 characters max." formErrorInput
                    [hasInputError]="validation.directory.nativeSubdirectoryInput.hasError"
                    [popoverAutomationId]="automationId + '-production-native-output-directory-error-message'">
            </div>
            <div class="export-row-column-auto">
                <div class="export-row">
                    <!-- <div class="export-row-column-auto">
                        <res-custom-checkbox [automationId]="automationId + '-production-native-image-exception'"
                            content="Image Exception Natives Only"
                            (click)="exportOptions.includeNativeFiles ? $event.stopPropagation() : null"
                            [(ngModel)]="exportOptions.separateImageExceptions"
                            [isDisabled]="optionsDisabled || !exportOptions.includeNativeFiles"
                            *ngIf="!updateExportVolume">
                        </res-custom-checkbox>
                    </div> -->
                    <!-- This checkbox is being commented out for now as it is intended for 5.x and not 5.0 -->
                    <div class="export-row-column-auto email-format">
                        <label
                            [ngClass]="{'disabled': optionsDisabled || !exportOptions.includeNativeFiles || !exportOptions.includeSeperateEmailAttachments || disabled.includeNativeFiles}">Email
                            Format:</label>
                        <select
                            [disabled]="optionsDisabled || !exportOptions.includeNativeFiles || !exportOptions.includeSeperateEmailAttachments || disabled.includeNativeFiles"
                            [attr.data-automation-id]="automationId + '-production-native-email-format-select'"
                            [(ngModel)]="exportOptions.emailOutputFormat"
                            (ngModelChange)="onChange.emailOutputFormat()"
                            (click)="exportOptions.includeNativeFiles ? $event.stopPropagation() : null"
                            [attr.title]="(!exportOptions.includeSeperateEmailAttachments) ? 'Enable the &quot;Separate Email Attachments&quot; in &quot;Family / Thread Options&quot; to enable this option' : ''">
                            <option value="NATIVE_FORMAT">Native</option>
                            <option value="HTML_FORMAT">HTML</option>
                            <option value="MHTML_FORMAT">MHTML</option>
                            <option value="HTML_MHTML_FORMAT">HTML/MHTML</option>
                            <option value="PDF_FORMAT">PDF</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="export-row" *ngIf="!hideOptions"
            [ngClass]="{'export-item-selected': exportOptions.includeTextConversion, 'export-item-disabled': optionsDisabled || disabled.includeTextConversion}">
            <div class="export-row-column-auto" [ngClass]="{'hide-header-class': isReefReviewProject}">
                <res-custom-checkbox [automationId]="automationId + '-production-extracted-text'"
                    content="Extracted Text" [ngModel]="exportOptions.includeTextConversion"
                    [isDisabled]="optionsDisabled || disabled.includeTextConversion"
                    (ngModelChange)="onChange.productionSettingType('Extracted Text')"></res-custom-checkbox>
            </div>
            <div class="export-row-column-auto" *ngIf="!isReefReviewProject">
                <input type="text"
                    [disabled]="optionsDisabled || !exportOptions.includeTextConversion || disabled.includeTextConversion"
                    (click)="exportOptions.includeTextConversion ? $event.stopPropagation() : null"
                    [(ngModel)]="validation.directory.textSubdirectoryInput.name"
                    [attr.data-automation-id]="automationId + '-production-extracted-text-output-directory-input'"
                    (ngModelChange)="validation.directory.textSubdirectoryInput.check()"
                    (focusin)="validation.directory.textSubdirectoryInput.check()"
                    (focusout)="validation.directory.textSubdirectoryInput.trimLeadingSpaces()"
                    (input)="validation.directory.textSubdirectoryInput.lengthValidation()"
                    [(resScrollablePopover)]="validation.directory.textSubdirectoryInput.invalid" [isSingleLine]="true"
                    [popoverErrorMessage]="this.validation.directory.textSubdirectoryInput.errorMessage"
                    [popoverType]="this.validation.directory.textSubdirectoryInput.errorType" popoverPlacement="bottom"
                    title="50 characters max." formErrorInput
                    [hasInputError]="validation.directory.textSubdirectoryInput.hasError"
                    [popoverAutomationId]="automationId + '-production-extracted-text-output-directory-error-message'">
            </div>
            <div class="export-row-column-auto">
                <res-custom-checkbox
                    [automationId]="automationId + '-production-extracted-text-exclude-header-information'"
                    content="Exclude Email Headers"
                    (click)="exportOptions.includeTextConversion ? $event.stopPropagation() : null"
                    [(ngModel)]="exportOptions.excludeEmailHeaders"
                    (ngModelChange)="onChange.excludeEmailHeaders()"
                    [isDisabled]="optionsDisabled || !exportOptions.includeTextConversion || disabled.includeTextConversion">
                </res-custom-checkbox>
            </div>
        </div>
        <div class="export-row" [ngStyle]="{'height' :  isHyland ? '75px' : ''}"
            [ngClass]="{'export-item-selected': exportOptions.includePdfConversion, 'export-item-disabled': optionsDisabled || disabled.includePdfConversion}">
            <div class="export-row-column-auto" [ngClass]="{'hide-header-class': isReefReviewProject}">
                <res-custom-checkbox [automationId]="automationId + '-production-pdf'" content="PDF"
                    [ngModel]="exportOptions.includePdfConversion"
                    [isDisabled]="optionsDisabled || disabled.includePdfConversion"
                    (ngModelChange)="onChange.productionSettingType('PDF')">
                </res-custom-checkbox>
            </div>
            <div class="export-row-column-auto" *ngIf="!isReefReviewProject">
                <input type="text"
                    [disabled]="optionsDisabled || !exportOptions.includePdfConversion || disabled.includePdfConversion"
                    (click)="exportOptions.includePdfConversion ? $event.stopPropagation() : null"
                    [(ngModel)]="validation.directory.pdfSubdirectoryInput.name"
                    [attr.data-automation-id]="automationId + '-production-pdf-output-directory-input'"
                    (ngModelChange)="validation.directory.pdfSubdirectoryInput.check()"
                    (focusin)="validation.directory.pdfSubdirectoryInput.check()"
                    (focusout)="validation.directory.pdfSubdirectoryInput.trimLeadingSpaces()"
                    (input)="validation.directory.pdfSubdirectoryInput.lengthValidation()"
                    [(resScrollablePopover)]="validation.directory.pdfSubdirectoryInput.invalid" [isSingleLine]="true"
                    [popoverErrorMessage]="validation.directory.pdfSubdirectoryInput.errorMessage"
                    [popoverType]="validation.directory.pdfSubdirectoryInput.errorType" popoverPlacement="bottom"
                    title="50 characters max." formErrorInput
                    [hasInputError]="validation.directory.pdfSubdirectoryInput.hasError"
                    [popoverAutomationId]="automationId + '-production-pdf-output-directory-error-message'">
            </div>
            <div class="export-row-column-auto">
                <res-custom-checkbox *ngIf="isHyland"
                    [automationId]="automationId + '-production-highlight-search-terms'"
                    content="Highlight Search Terms"
                    (click)="exportOptions.includePdfConversion ? $event.stopPropagation() : null"
                    [(ngModel)]="exportOptions.highlightTerms"
                    [isDisabled]="optionsDisabled || !exportOptions.includePdfConversion || disabled.includePdfConversion || !exportOptions.includeSeperateEmailAttachments"
                    (ngModelChange)="onChange.productionSettingType('Search Terms')">
                </res-custom-checkbox>
                <res-custom-checkbox [automationId]="automationId + '-generate-remaining-images'"
                    content="Generate Remaining Images"
                    (click)="exportOptions.includePdfConversion ? $event.stopPropagation() : null"
                    [(ngModel)]="exportOptions.convertImagesToPdf"
                    [isDisabled]="optionsDisabled || !exportOptions.includePdfConversion || disabled.includePdfConversion"
                    (ngModelChange)="onChange.productionSettingType('Search Terms')">
                </res-custom-checkbox>
            </div>
        </div>
        <!-- <div class="export-row"
            [ngClass]="{'export-item-selected': exportOptions.includeTiffConversion, 'export-item-disabled': optionsDisabled || disabled.includeTiffConversion}">
            <div class="export-row-column-auto">
                <res-custom-checkbox [automationId]="automationId + '-production-tiff'" content="TIFF"
                    [ngModel]="exportOptions.includeTiffConversion"
                    [isDisabled]="optionsDisabled || disabled.includeTiffConversion"
                    (ngModelChange)="onChange.productionSettingType('TIFF')">
                </res-custom-checkbox>
            </div>
            <div class="export-row-column-auto">
                <input type="text"
                    [disabled]="optionsDisabled || !exportOptions.includeTiffConversion || disabled.includeTiffConversion"
                    (click)="exportOptions.includeTiffConversion ? $event.stopPropagation() : null"
                    [(ngModel)]="validation.directory.tiffSubdirectoryInput.name"
                    [attr.data-automation-id]="automationId + '-production-tiff-output-directory-input'"
                    (ngModelChange)="validation.directory.tiffSubdirectoryInput.check()"
                    (focusin)="validation.directory.tiffSubdirectoryInput.check()"
                    (focusout)="validation.directory.tiffSubdirectoryInput.trimLeadingSpaces()"
                    (input)="validation.directory.tiffSubdirectoryInput.lengthValidation()"
                    [(resScrollablePopover)]="validation.directory.tiffSubdirectoryInput.invalid" [isSingleLine]="true"
                    [popoverErrorMessage]="validation.directory.tiffSubdirectoryInput.errorMessage"
                    [popoverType]="validation.directory.tiffSubdirectoryInput.errorType" popoverPlacement="bottom"
                    title="50 characters max." formErrorInput
                    [hasInputError]="validation.directory.tiffSubdirectoryInput.hasError"
                    [popoverAutomationId]="automationId + '-production-tiff-output-directory-error-message'">
            </div>
            <div class="export-row-column-auto">
                <res-custom-radio-button [automationId]="automationId + '-production-tiff-single-page'"
                    [(ngModel)]="exportOptions.tiffMode" content="Single Page" name="tiffPage" value="SINGLE_PAGE"
                    [disabled]="optionsDisabled || !exportOptions.includeTiffConversion || disabled.includeTiffConversion"
                    (click)="exportOptions.includeTiffConversion ? $event.stopPropagation() : null">
                </res-custom-radio-button>
                <res-custom-radio-button [automationId]="automationId + '-production-tiff-multi-page'"
                    [(ngModel)]="exportOptions.tiffMode" content="Multi-Page" name="tiffPage" value="MULTI_PAGE"
                    [disabled]="optionsDisabled || !exportOptions.includeTiffConversion || disabled.includeTiffConversion"
                    (click)="exportOptions.includeTiffConversion ? $event.stopPropagation() : null">
                </res-custom-radio-button>
            </div>
        </div> -->
        <!-- COmmenting TIFF section out for now as it will be removed as part of http://172.31.240.173:8080/browse/ECASL-35557 or http://172.31.240.173:8080/browse/ECASL-34978 anyway  -->
    </div>
    <!-- <div class="export-row-column-auto">
        <div class="export-header">Imaging Settings</div>
        <div class="export-row export-row-padded">
            <div class="export-row-column-auto">
                <label [ngClass]="{'disabled': optionsDisabled || disabled.tiffBW()}">Color
                    mode:</label>
            </div>
            <div class="export-row-column-auto">
                <res-custom-radio-button
                    [attr.title]="(disabled.tiffBW()) ? 'Enable PDF or TIFF output to enable this option' : ''"
                    [automationId]="automationId + '-color-mode-bw'" [(ngModel)]="exportOptions.tiffBW" content="B&W"
                    name="tiffColor" [value]="true" [disabled]="optionsDisabled || disabled.tiffBW()"
                    (click)="exportOptions.includeTiffConversion ? $event.stopPropagation() : null">
                </res-custom-radio-button>
                <res-custom-radio-button
                    [attr.title]="(disabled.tiffBW()) ? 'Enable PDF or TIFF output to enable this option' : ''"
                    [automationId]="automationId + '-color-mode-color'" [(ngModel)]="exportOptions.tiffBW"
                    content="Color" name="tiffColor" [value]="false" [disabled]="optionsDisabled || disabled.tiffBW()"
                    (click)="exportOptions.includeTiffConversion ? $event.stopPropagation() : null">
                </res-custom-radio-button>
            </div>
        </div>
        <res-custom-checkbox [automationId]="automationId + '-generate-remaining-images'"
            content="Generate Remaining Images" [(ngModel)]="exportOptions.convertImagesToPdf"
            [isDisabled]="optionsDisabled || disabled.tiffBW()"
            [attr.title]="(disabled.tiffBW()) ? 'Enable PDF or TIFF output to enable this option' : ''">
        </res-custom-checkbox>
    </div> -->
</div>